export const columns = [
  { name: "Id", cell: (row) => row["id"] },
  {
    name: "Payee",
    cell: (row) => row["payee"],
  },
  {
    name: (
      <div className='sc-dQoVA huizgM'>
        Collection
        <br /> Account
      </div>
    ),
    cell: (row) =>
      row["collectionAccount"] === "COK MTN" ? "COK MTN SPA" : "",
  },
  {
    name: (
      <div className='sc-dQoVA huizgM'>
        Payee
        <br /> Number
      </div>
    ),
    cell: (row) => (
      <div style={{ whiteSpace: "nowrap" }}>{row["payeeNumber"]}</div>
    ),
  },
  { name: "TID", cell: (row) => row["tid"] },
  { name: "PRID", cell: (row) => row["prid"] },
  { name: "FRID", cell: (row) => row["frid"] },
  { name: "Amount", cell: (row) => row["amount"] },
  { name: "Info", cell: (row) => row["info"] },
  { name: "Status", cell: (row) => row["status"] },
  { name: "Datetime", cell: (row) => row["datetime"] },
];